import styled from './detpedido.module.css';
import { AuthContext } from '../../services/global';
import { useContext, useEffect, useState } from 'react';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import { useNavigate,Link } from 'react-router-dom';
import api from '../../services/api';
import { Alerta } from '../../utils/functions';

function DetPedido() {
    const { dadosped } = useContext(AuthContext);
    const login = JSON.parse(localStorage.getItem("login"));
    const nomcli = login.nomcli;
    const endcli = login.endcli;
    const Navigate = useNavigate('');
    const [itens, setitens] = useState([]);

    function Voltar(wpage) {
        Navigate(wpage);
    }

    async function GetItens() {
        await api.get(`pedidos/itens/?numped=${dadosped[0].numped}`)
            .then((response) => {
                if (!response.data.msg) {
                    setitens(response.data);
                } else {
                    Alerta('Erro', response.data.msg, 'error');
                }
            }).catch((erro) => {
                Alerta('Erro', erro, 'error');
            })
    }

    async function GetPDF() {
        await api.get(`pedidos/download/?numped=${dadosped[0].numped}`, { responseType: 'blob' })
            .then((response) => {
                if (!response.data.msg) {

                    let blob = new Blob([response.data], {
                        type: 'application/pdf'
                    });
                    let url = window.URL.createObjectURL(blob)
                    window.open(url);
                } else {
                    Alerta('Erro', response.data.msg, 'error');
                }
            }).catch((erro) => {
                Alerta('Erro', erro, 'error');
            })
    }

    async function GetNota() {
        await api.get(`pedidos/nfe/?numnot=${dadosped[0].numnot}`, { responseType: 'blob' })
            .then((response) => {
                if (!response.data.msg) {

                    let blob = new Blob([response.data], {
                        type: 'application/pdf'
                    });
                    let url = window.URL.createObjectURL(blob)
                    window.open(url);
                } else {
                    Alerta('Erro', response.data.msg, 'error');
                }
            }).catch((erro) => {
                Alerta('Erro', erro, 'error');
            })
    }

    useEffect(() => {
        GetItens();
    }, [])


    return (
        <div className={styled.page}>
            <Menu menu="pedidos" />
            <div className={styled.container}>
                <Header page={`Pedido Nº ${dadosped[0].numped}`} />
                <div className={styled.content}>
                    <div className={styled.card}>
                        <div className={styled.card01}>
                            <div className={styled.card01content}>
                                <div className={styled.card01appdetalhes}>
                                    <div className={styled.card01header}>
                                        <a onClick={() => Voltar(dadosped[0].page)}>&lt; VOLTAR PARA LISTA DE PEDIDOS</a>
                                    </div>
                                    <div className={styled.car01dados}>
                                        <div className={styled.card01dadoscontent}>
                                            <div className={styled.card01dadoscontentlabel}>
                                                <a>NUMERO DO PEDIDO</a>
                                                <span>{dadosped[0].numped}</span>
                                            </div>
                                            <div className={styled.card01dadoscontentlabel}>
                                                <a>ORDEM DE COMPRA</a>
                                                <span>{dadosped[0].ordem}</span>
                                            </div>
                                            <div className={styled.card01dadoscontentlabel}>
                                                <a>DATA DA SOLICITAÇÃO</a>
                                                <span>{dadosped[0].data}</span>
                                            </div>
                                            <div className={styled.card01dadoscontentlabel}>
                                                <a>NOME DO SOLICITANTE</a>
                                                <span>{nomcli}</span>
                                            </div>
                                            <div className={styled.card01dadoscontentlabelend}>
                                                <a>ENDEREÇO DE ENTREGA</a>
                                                <p>{endcli}</p>
                                                
                                            </div>
                                            <div className={styled.card01dadoscontentlabel}>
                                                <a>VALOR TOTAL</a>
                                                <span>{dadosped[0].valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styled.card02}>
                            <div className={styled.card02header}>
                                <div className={styled.card02title}>
                                    <a>Situação do Pedido</a>
                                    <div className={styled.card02line}></div>
                                </div>
                            </div>
                            <div className={styled.card02content}>
                                <div className={styled.card02app}>
                                    <div className={styled.card02situa}>
                                        <div className={styled.card02status}>
                                            {dadosped[0].status == 'EM TRANSPORTE' ? <div className={styled.statustrans}></div> : null}
                                            {dadosped[0].status == 'PRODUZINDO' ? <div className={styled.statusprod}></div> : null}
                                            {dadosped[0].status == 'ENTREGUE' ? <div className={styled.statusentregue}></div> : null}
                                            {dadosped[0].status == 'PEDIDO RECEBIDO' ? <div className={styled.statusrecebido}></div> : null}
                                            {dadosped[0].status == 'EM ANALISE' ? <div className={styled.statusanalise}></div> : null}
                                        </div>
                                        <div className={styled.card02statuslabel}>
                                            <a>{dadosped[0].status}</a>
                                            <span>{dadosped[0].status == 'ENTREGUE' ? dadosped[0].datent : ''}</span>
                                        </div>
                                    </div>
                                    {dadosped[0].numnot != '000000' ?
                                        <div onClick={() => GetNota()} className={styled.btnnota}>BAIXAR NOTA FISCAL</div>
                                        :
                                        <div className={styled.btnnota1}>NOTA FISCAL NÃO EMITIDA</div>
                                    }
                                    <div onClick={() => GetPDF()} className={styled.btnpedido}>BAIXAR PEDIDO</div>
                                    {dadosped[0].numnot != '000000' ?
                                    <Link to="/Financeiro" className={styled.btnnota}>CONSULTAR BOLETOS</Link>
                                    :
                                    <div className={styled.btnnota1}>CONSULTAR BOLETOS</div>}
                                </div>
                            </div>
                        </div>

                        <div className={styled.card03}>
                            <div className={styled.card03header}>
                                <div className={styled.card03title}>
                                    <a>Produtos</a>
                                    <div className={styled.card03line}></div>
                                </div>
                            </div>
                            <div className={styled.card03content}>
                                <div className={styled.card03app}>
                                    {itens.map((item) => {
                                        return (
                                            <div className={styled.card03item}>
                                                <img src={item.urlimg} className={styled.card03itemimg} />
                                                <div className={styled.card03itemcontent}>
                                                    <a>Cód. {item.codpro}</a>
                                                    <a>{item.nompro}</a>
                                                    <span>{item.qtdven} unidade</span>
                                                    <span>* Valores unitários sem impostos.</span>
                                                    <span>{item.valven.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div >
    )
}


export default DetPedido;